import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Main-Layout" }
const _hoisted_2 = { class: "App-Main-Layout-M-H" }
const _hoisted_3 = { class: "App-Main-Layout-M" }
const _hoisted_4 = { class: "App-Main-Layout-M" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      gutter: 10,
      type: "flex",
      align: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_affix, {
              target: "body",
              position: "top",
              offset: 0
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "left")
              ]),
              _: 3
            })
          ]),
          _: 3
        }),
        _createVNode(_component_el_col, { span: 19 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_affix, {
                target: "body",
                position: "top",
                offset: 0
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "top")
                  ])
                ]),
                _: 3
              }),
              _createElementVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "main")
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ]))
}